import { render, staticRenderFns } from "./UShowForms.vue?vue&type=template&id=48b09d6a&"
import script from "./UShowForms.vue?vue&type=script&lang=js&"
export * from "./UShowForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports